import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "./scss/main.scss";
import { BrowserRouter as Router } from "react-router-dom";
import axios from "axios";
import Loader from "./component/Loader"


axios.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (error && 401 === error.response.status) {
    localStorage.removeItem('user');
    window.location.href = "/"
  } else {
    // This is important, so that unhandled cases make axios throw errors
    return Promise.reject(error);
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Router>
      <Loader />
      <App />
    </Router>
  </React.StrictMode>
);
